/*
This map is used to generate the folder structure during the build process.
If a path is not added here, the refresh will rely on 404.html to redirect to index.html,
which makes the search engines not index the page.
 */

const routePaths = {
  INDEX: '',
  QUICK_SETUP: 'quick-setup',
  GAME: 'game',
  MENU: 'menu',
  // Room code travels via the `room` query param to avoid dynamic-segment prerender/404 handling
  ONLINE: 'online',
  // The host's song browser — its own route so the back button returns to the lobby. Rendered by the
  // same `Online` route entry (see app.tsx), which is what keeps the room connection alive across it
  ONLINE_PICK_SONG: 'online/pick-song',
  JUKEBOX: 'jukebox',
  HISTORY: 'history',
  PROFILES: 'profiles',
  STATS: 'stats',
  SELECT_INPUT: 'select-input',
  SETTINGS: 'settings',
  SETTINGS_REMOTE_MICS: 'settings/remote-mics',
  SETTINGS_CALIBRATION: 'settings/calibration',
  REMOTE_MIC: 'remote-mic',
  MANAGE_SONGS: 'manage-songs',
  ADMIN: 'admin',
  EXCLUDE_LANGUAGES: 'exclude-languages',
  CONVERT: 'convert',
  EDIT_SONGS_LIST: 'edit/list',
  EDIT_SONG: 'edit/song',
  EDIT_SETLISTS: 'edit/setlists',
} as const;

export default routePaths;
